var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01057 8.04728C8.34753 9.99213 9.53177 11.3242 11.6239 12C13.716 11.3242 14.9002 9.99213 15.2372 8.04728C15.2572 7.91731 15.2488 7.78455 15.2125 7.65816C15.1762 7.53177 15.1129 7.41476 15.027 7.3152C14.9411 7.21564 14.8346 7.1359 14.7149 7.08149C14.5952 7.02707 14.4651 6.99928 14.3336 7.00001H8.9142C8.7827 6.99928 8.65261 7.02707 8.5329 7.08149C8.41319 7.1359 8.30671 7.21564 8.2208 7.3152C8.1349 7.41476 8.07161 7.53177 8.03532 7.65816C7.99902 7.78455 7.99058 7.91731 8.01057 8.04728Z",
    fill: "#808080",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91423 17C8.78279 17.0007 8.65276 16.9729 8.5331 16.9185C8.41343 16.8642 8.30699 16.7845 8.22109 16.685C8.1352 16.5855 8.0719 16.4686 8.03556 16.3423C7.99922 16.2159 7.9907 16.0832 8.01059 15.9533C8.34756 14.0085 9.5318 12.6764 11.6239 12C13.716 12.6764 14.9003 14.0085 15.2372 15.9533C15.2571 16.0832 15.2486 16.2159 15.2123 16.3423C15.1759 16.4686 15.1126 16.5855 15.0267 16.685C14.9408 16.7845 14.8344 16.8642 14.7147 16.9185C14.5951 16.9729 14.465 17.0007 14.3336 17H8.91423Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.89c8da972b602ad363e0464e89d0229e.svg";
export { ForwardRef as ReactComponent };